import React from 'react';
import styles from './PcccGrid.module.scss';

// Header Img
import PhysicalityHeader from '../../../../static/media/about/physicality.png';
import CompanionshipHeader from '../../../../static/media/about/companionship.png';
import CommunicationHeader from '../../../../static/media/about/communication.png';
import ClarityHeader from '../../../../static/media/about/clarity.png';

const PcccGrid = () => (
  <div className={styles['pccc-grid']}>
    <div className={styles['pccc-grid__item-a']}>
      <div>
        <img src={PhysicalityHeader} alt="Physicality" />
      </div>
      <ul>
        <li>
          A physically exceptional act that utilizes our current life
          circumstances.
        </li>
        <li>An exploration of our body's potential.</li>
        <li>A deepend understanding of our body's communications.</li>
        <li>Routine performance of the act.</li>
        <li>A prioritization of long term body health</li>
      </ul>
    </div>
    <div className={styles['pccc-grid__item-b']}>
      <div>
        <img src={CompanionshipHeader} alt="Companionship" />
      </div>
      <ul>
        <li>
          Utilizing our current life circumstances of intentioned interaction.
        </li>
        <li>
          Maximizing physical proximity for shared understanding potential.
        </li>
        <li>Combining concerted effort for a mutual goal.</li>
        <li>Sharing needs, aligning needs.</li>
        <li>Celebrating disperate experience in a parallel commitment.</li>
      </ul>
    </div>
    <div className={styles['pccc-grid__item-c']}>
      <div>
        <img src={CommunicationHeader} alt="Communication" />
      </div>
      <ul>
        <li>Expression of experience in a benevolent manner.</li>
        <li>Expression with meaning and principle</li>
        <li>Intentional openness in encountered dialogue.</li>
        <li>
          Facilitating conversations around the project's context and beyond.
        </li>
        <li>Intentioned choice in medium and frequency.</li>
      </ul>
    </div>
    <div className={styles['pccc-grid__item-d']}>
      <div>
        <img src={ClarityHeader} alt="Clarity" />
      </div>
      <ul>
        <li>Pursuit of personal clarity.</li>
        <li>Pursuit of paired clarity.</li>
        <li>Pursuit of communal clarity.</li>
        <li>Pursuit through outward awareness.</li>
        <li>Pursuit through inward awarenness.</li>
      </ul>
    </div>
  </div>
);

export default PcccGrid;
